import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { Card, Row, Modal, Spin, Pagination, Select, Button } from "antd";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useDispatch } from "react-redux";
import { setLoading } from "../../redux/globalSlice.ts";
import AssetService from "../../services/AssetService.ts";
import videoUploadService from "../../services/VideoUploadService.ts";
import "../../app.css";
import { CloseOutlined, FullscreenOutlined } from "@ant-design/icons";
import nodata from "../../assets/images/nodata.svg";
import Hls from "hls.js";
import assetCategoryService from "../../services/asset-category-service.ts";
import { sanitizeFileNamePdf, sanitizeFileNameVideo } from "../../utils/sanitizeUrl.ts";


const REACT_APP_VIDEO_BASE_URL = process.env.REACT_APP_VIDEO_BASE_URL;
const REACT_APP_THUMBNAIL_BASE_URL = process.env.REACT_APP_THUMBNAIL_BASE_URL;
const REACT_APP_VIDEO_CLOUDFRONT_URL = process.env.REACT_APP_VIDEO_CLOUDFRONT_URL;

const Heighlights = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [categories, setCategories] = useState<{ value: string; label: string }[]>([]);

  const [selectedCategory, setSelectedCategory] =
    useState<string>("");
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    totalPages: 1,
  });

  const { current: currentPage, pageSize: pageSizeValue } = pagination;
  const [selectedVideo, setSelectedVideo] = useState<{
    url: string;
    category: string;
  } | null>(null);
  const [isFetchingVideo, setIsFetchingVideo] = useState(false);
  const dispatch = useDispatch();
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const iframeRef = useRef<HTMLIFrameElement | null>(null);
  const [groupedAssets, setGroupedAssets] = useState<{ [key: string]: any[] }>({});

      useEffect(() => {
        const fetchData = async () => {
          try {
            dispatch(setLoading(true));
      const categoryData = await assetCategoryService.getAllCategoriesWithoutPagination();
      const categoryList = categoryData.data || [];
      const formattedCategories = categoryList.map((cat: any) => ({
        value: cat.CategoryName,
        label: cat.CategoryName,
      }));
      setCategories(formattedCategories);
      const categoryParam = selectedCategory && selectedCategory !== "" ? selectedCategory : undefined;

    const response = await AssetService.getAssetsForHighlights(
      currentPage,
      pageSizeValue,
      categoryParam
    );

    let assets = response.data.assets || [];
    const { totalRecords, totalPages } = response.data.pagination;

    const uniqueAssets = assets.reduce((acc: any[], asset: any) => {
      if (!acc.some((a) => a.AssetsID === asset.AssetsID)) acc.push(asset);
      return acc;
    }, []);

    const grouped: { [key: string]: any[] } = {};
    uniqueAssets.forEach(asset => {
      const cat = asset.Category || "Uncategorized";
      if (!grouped[cat]) grouped[cat] = [];
      grouped[cat].push(asset);
    });

    setGroupedAssets(grouped);

    setPagination((prev) => ({
      ...prev,
      total: totalRecords,
      totalPages,
    }));
    } catch (error) {
      console.error("Error fetching assets or categories:", error);
    } finally {
      dispatch(setLoading(false));
    }
  };

  fetchData();
}, [selectedCategory, currentPage, pageSizeValue, dispatch]);

  const handlePaginationChange = (page: number, pageSize: number) => {
    setPagination((prev) => ({ ...prev, current: page, pageSize }));
  };

  const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

  const showModal = async (
    AssetID: number,
    fileName: string,
    category: string
  ) => {
    setIsFetchingVideo(true);
    setIsModalOpen(true);

    try {
      if (category === "Video") {
        await delay(50);
        const sanitized = sanitizeFileNameVideo(fileName);
        const fileUrl = `${REACT_APP_VIDEO_CLOUDFRONT_URL}/Outputs/${AssetID}/${sanitized}.m3u8`;
        setSelectedVideo({ url: fileUrl, category });
      } else {
      const sanitizedFileName = sanitizeFileNamePdf(fileName);
        const fileUrl = `${REACT_APP_VIDEO_CLOUDFRONT_URL}/assets/${AssetID}/${sanitizedFileName}`
        setSelectedVideo({ url: fileUrl, category });
      }
    } catch (error) {
      console.error("Error fetching file URL:", error);
    } finally {
      setIsFetchingVideo(false);
    }
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setSelectedVideo(null);
  };

  const defaultVideoThumbnail = "/video.jpg";
  const defaultPdfThumbnail = "/pdf.png";

  const getThumbnailUrl = (assetId: number, thumbnail: string) => {
    if (!thumbnail) return defaultVideoThumbnail;
    return `${REACT_APP_THUMBNAIL_BASE_URL}/${assetId}/${thumbnail}`;
  };

  useEffect(() => {
    if (selectedVideo?.category === "Video" && videoRef.current) {
      if (Hls.isSupported()) {
        const hls = new Hls();
        hls.loadSource(selectedVideo.url);
        hls.attachMedia(videoRef.current);
        return () => {
          hls.destroy();
        };
      } else if (
        videoRef.current.canPlayType("application/vnd.apple.mpegurl")
      ) {
        videoRef.current.src = selectedVideo.url;
      }
    }
  }, [selectedVideo]);

  const toggleFullScreen = () => {
    if (iframeRef.current) {
      if (document.fullscreenElement) {
        document.exitFullscreen();
      } else {
        iframeRef.current.requestFullscreen().catch(console.error);
      }
    }
  };

  const getAssetThumbnail = (asset: any) => {
  if (asset.Thumbnail) {
    return getThumbnailUrl(asset.AssetsID, asset.Thumbnail);
  }

  if (asset.Type === "PDF") {
    return defaultPdfThumbnail;
  }

  return defaultVideoThumbnail;
};


    const getTabContent = () => {
      const categoryKeys = Object.keys(groupedAssets);

      return (
        <div className="">
          {categoryKeys.length > 0 ? (
            <>
              {categoryKeys.map((cat) => (
                <div key={cat}>
                  <h1 className="vm__card_title">{cat}</h1>
                  <div className="vm__container-loop vm__mb-3 vm__has-no-slider">
                    {groupedAssets[cat].map((item) => (
                      <Card
                        key={`${item.Type}-${item.AssetsID}`}
                        className="vm__media-card vm__h-100 vm__flex-bind"
                        onClick={() => showModal(item.AssetsID, item.URL, item.Type)}
                      >
                        <div className="vm__media-card__thumbnail vm__flex-auto">
                          <img
                          src={getAssetThumbnail(item)}
                          alt={item.Title}
                        />

                        </div>
                        <div className="vm__media-card__meta vm__flex-fill vm__custom-padding">
                          <div className="vm__d-flex vm__gap-2 vm__align-items-center">
                            <div className="vm__flex-fill">
                              <h1 className="vm__h5 vm__mb-0">
                                <Link to="#" className="vm__text-clamp-2">
                                  {item.Title}
                                </Link>
                                <span className="vm__sub-head vm__text-clamp-1">
                                  {item.Type}
                                </span>
                              </h1>
                            </div>
                          </div>
                        </div>
                      </Card>
                    ))}
              </div>
            </div>
          ))}
          {pagination.total > 10 && (
            <div className="vm__pagination-container" style={{ display: "flex", justifyContent: "flex-end", marginTop: "20px", padding: "10px 0" }}>
              <Pagination
                current={pagination.current}
                pageSize={pagination.pageSize}
                total={pagination.total}
                onChange={handlePaginationChange}
                showSizeChanger
                pageSizeOptions={["10", "20", "50", "100"]}
                hideOnSinglePage={false}
              />
            </div>
          )}
        </>
      ) : (
        <div className="vm__no-results">
          <span className="vm__nodata-container">
            <img src={nodata} alt="No data" />
          </span>
          <p>No materials found for this category.</p>
        </div>
      )}
    </div>
  );
};






  const renderContent = () => {
    if (isFetchingVideo) {
      return (
        <div className="vm__modal-loader">
          <Spin size="large" />
        </div>
      );
    }

    if (!selectedVideo) return null;

    return selectedVideo.category === "PDF" ? (
      <div style={{ position: "relative", height: "100%" }}>
        <FullscreenOutlined
          onClick={toggleFullScreen}
          style={{
            position: "absolute",
            bottom: 25,
            right: 25,
            zIndex: 10,
            fontSize: "24px",
            color: "#000",
            background: "#fff",
            borderRadius: "5px",
            padding: "5px",
            cursor: "pointer",
            boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
          }}
        />
        <iframe
          ref={iframeRef}
          src={selectedVideo.url}
          width="100%"
          height="100%"
          style={{ border: "none", height: "calc(100vh - 200px)" }}
          title="PDF Viewer"
        />
      </div>
    ) : (
      <video
        ref={videoRef}
        controls
        width="100%"
        height="auto"
        style={{ maxHeight: "calc(100vh - 200px)", background: "#000" }}
      />
    );
  };

  return (
    <>
      <div className="vm__h-100 vm__overflow-auto">
        <div className="vm__d-flex vm__h-100 vm__flex-column">
          <div className="vm__flex-auto">
            <Row>
              <div className="vm__container vm__h-100">
                <h3 className="vm__page-header vm__mb-3">Highlights</h3>
              </div>
            </Row>
          </div>
          <div className="vm__flex-auto">
            <div className="vm__container">
              <div className="vm__d-flex vm__gap-3 vm__align-items-center vm__mb-3">
                <div className="vm__flex-auto">
          <Button
            type="primary"
            onClick={() => {
              setSelectedCategory(""); 
              setPagination((prev) => ({ ...prev, current: 1 }));
            }}
          >
            All materials
          </Button>


                </div>
                <div className="vm__flex-fill">
                <Select
                 
                  showSearch
                  placeholder="Select a category"
                  value={selectedCategory|| undefined}
                  onChange={(value) => setSelectedCategory(value)}
                  filterOption={(input, option) =>
                    (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                  }
                  options={categories}
                  style={{ width: "50%" }}
                />
                </div>
              </div>
            </div>
          </div>
          <div className="vm__flex-fill vm__overflow-auto">
        <div className="vm__container">
          {getTabContent()}
        </div>

          </div>
        </div>
      </div>

      <Modal
        centered
        open={isModalOpen}
        onCancel={handleCancel}
        destroyOnClose
        footer={null}
        className="vm__w-100 vm__video-modal vm__position-relative"
        width="90%"
        bodyStyle={{ height: "80vh", padding: 0, position: "relative" }}
        closable={false}
        maskClosable={false}
      >
        <button onClick={handleCancel} className="vm__video-close">
          <CloseOutlined />
        </button>
        {renderContent()}
      </Modal>
    </>
  );
};

export default Heighlights;
